<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月31日 15:19:42 +0800
 * @最后修改时间: 2021-08-03 15:57:05
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Claim\ClaimType\components\editClaimFieldDialog.vue
 -->
<template>
  <normalDialog
    width="600"
    @close="closeDialog"
    scrollable
    title="Edit Field"
    :dialog="show"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :bindData="ClaimFieldData.custom_field_label"
              @change="
                (valueArr) => {
                  ClaimFieldData.custom_field_label = valueArr;
                }
              "
              label="Label"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            Form Builder Field Type:
            <v-select
              v-model="ClaimFieldData.formbuilder_uuid"
              :items="allFieldType"
              item-text="view_fields"
              item-value="value_field"
              filled
              :rules="$GetRules('_Require_Rules', [null])"
              single-line
              hide-details
              dense
              label="Field Type"
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-select>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :bindData="ClaimFieldData.custom_field_name"
              @change="
                (valueArr) => {
                  ClaimFieldData.custom_field_name = valueArr;
                }
              "
              label="Name"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            Description:
            <v-textarea
              rows="5"
              no-resize
              maxlength="500"
              v-model="ClaimFieldData.custom_field_description"
              dense
              counter="500"
              single-line
              :rules="$GetRules(['_Require_Rules'], [null])"
              hide-details
              filled
            ></v-textarea>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            Data Type:
            <v-select
              v-model="ClaimFieldData.custom_field_data_type"
              :items="allDataType"
              filled
              :rules="$GetRules('_Require_Rules', [null])"
              single-line
              hide-details
              dense
              label="Data Type"
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-select>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            Data Length:
            <v-text-field
              label="Data Length"
              type="number"
              filled
              :rules="$GetRules(['_Number_negative'], [null])"
              v-model="ClaimFieldData.custom_field_data_length"
              single-line
              placeholder="Data Length"
              hide-details
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            Date Decimal:
            <v-text-field
              label="Date Decimal"
              type="number"
              filled
              v-model="ClaimFieldData.custom_field_data_decimal"
              single-line
              :rules="$GetRules(['_Number_negative'], [null])"
              placeholder="Date Decimal"
              hide-details
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            Date Format:
            <v-text-field
              label="Date Format"
              filled
              v-model="ClaimFieldData.custom_field_data_format"
              single-line
              placeholder="Date Format"
              hide-details
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            Related Table:
            <v-select
              v-model="ClaimFieldData.custom_field_relate_to_table"
              :items="allTable"
              item-text="view_fields"
              item-value="value_field"
              hide-details
              filled
              single-line
              dense
              label="Related Table"
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-select>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            Related Field:
            <v-select
              v-model="ClaimFieldData.custom_field_relate_to_field"
              :items="allField"
              item-text="view_fields"
              item-value="value_field"
              filled
              single-line
              hide-details
              dense
              label="Related Field"
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-select>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-checkbox
              v-model="ClaimFieldData.is_required"
              color="primary"
              label="Required"
            ></v-checkbox>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-checkbox
              v-model="ClaimFieldData.is_unique"
              color="primary"
              label="Unique"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <CardActions saveBtn cancelBtn @save="onEdit" @cancel="closeDialog" />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "newClaimFieldDialog",
  computed: {
    ...mapGetters(["companyLang"]),
    curtable() {
      return this.ClaimFieldData.custom_field_relate_to_table;
    },
  },
  props: ["show", "mappingData"],

  data() {
    return {
      ClaimFieldData: {
        id: null,
        custom_field_label: "",
        formbuilder_uuid: "",
        custom_field_name: "",
        custom_field_description: "",
        custom_field_data_length: 0,
        custom_field_data_type: "",
        custom_field_data_decimal: "",
        custom_field_data_format: "",
        custom_field_relate_to_table: "",
        custom_field_relate_to_field: "",
        is_required: false,
        is_unique: false,
        remarks: "",
      },
      allTable: [],
      allDataType: ["varchar", "int", "double", "datetime"],
      allField: [],
      allFieldType: [],
    };
  },
  watch: {
    mappingData(val) {
      if (!val) return;
      this.ClaimFieldData = {
        id: val.id,
        custom_field_label: val.custom_field_label,
        formbuilder_uuid: val.formbuilder_uuid,
        custom_field_name: val.custom_field_name,
        custom_field_description: val.custom_field_description,
        custom_field_data_length: val.custom_field_data_length,
        custom_field_data_type: val.custom_field_data_type,
        custom_field_data_decimal: val.custom_field_data_decimal,
        custom_field_data_format: val.custom_field_data_format,
        custom_field_relate_to_table: val.custom_field_relate_to_table,
        custom_field_relate_to_field: val.custom_field_relate_to_field,
        is_required: val.is_required,
        is_unique: val.is_unique,
        remarks: val.remarks,
      };
    },
    curtable(val) {
      const that = this;
      this.allField = [];
      this.ClaimFieldData.custom_field_relate_to_field = "";
      if (val != "") {
        //高级参照查Field
        this.$findPrompt({
          prompt_name: "ess_field_select",

          table_uuid: val,
        })
          .then((res) => {
            that.allField = res.data;
          })
          .catch((err) => {
            that.$showMessage({
              title: that.$t("message_essweb_form_textField_errNoticeTitle"),
              type: "error",
              text: err,
            });
          });
      }
    },
  },
  mounted() {
    const that = this;
    this.ClaimFieldData.custom_field_label = this.$getCommonLangKey(
      this.companyLang
    );
    this.ClaimFieldData.custom_field_name = this.$getCommonLangKey(
      this.companyLang
    );
    //高级参照查Form Type
    this.$findPrompt({
      prompt_name: "ess_form_type_select",
    })
      .then((res) => {
        that.allFieldType = res.data;
      })
      .catch((err) => {
        that.$showMessage({
          title: that.$t("message_essweb_form_textField_errNoticeTitle"),
          type: "error",
          text: err,
        });
      });
    //高级参照查Table
    this.$findPrompt({
      prompt_name: "ess_table_select",
      table_type: 1,
    })
      .then((res) => {
        that.allTable = res.data;
      })
      .catch((err) => {
        that.$showMessage({
          title: that.$t("message_essweb_form_textField_errNoticeTitle"),
          type: "error",
          text: err,
        });
      });
  },
  methods: {
    closeDialog: function () {
      this.$emit("close");
    },
    onEdit: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$emit("onEdit", this.ClaimFieldData);
    },
  },
};
</script>
